<script lang="ts">
  interface SvgIconProps {
    /**
     * 图标类名
     * @default ''
     */
    class?: string;
    /**
     * 图标前缀，用于构建symbolId
     * @default 'icon'
     */
    prefix?: string;
    /**
     * 图标名称（必填）
     */
    name: string;
    /**
     * 图标尺寸（同时作为宽高的默认值）
     * @default 16
     */
    size?: number | string;
    /**
     * 图标宽度（优先级高于size）
     * @default 0
     */
    width?: number;
    /**
     * 图标高度（优先级高于size）
     * @default 0
     */
    height?: number;
    /**
     * 是否转换尺寸单位为rem
     * @default false
     */
    rem?: boolean;

    /**
     * 其他属性
     */
    [key: string]: unknown;

    onclick?: (e: Event) => void;
  }

  const { prefix = "icon", name, size = 16, width = 0, height = 0, rem = false, class: className, onclick, ...restProps }: SvgIconProps = $props();
  /**
   * 将px值转换为rem
   * @param {string|number} pxValue - 需要转换的px值
   * @returns {string} 转换后的rem值
   */
  function pxToRem(pxValue: string | number) {
    pxValue = Number(pxValue.toString().replace("px", "") || 0);
    const baseFontSize = 100;
    return pxValue / baseFontSize + "rem";
  }

  const symbolId = $derived(`#${prefix}-${name}`);

  /**
   * 计算svg的样式
   * @returns {string} svg的样式字符串
   */
  const style = $derived.by(() => {
    let s = `${String(size).replace("px", "")}px`;
    let w: string = (width && `${width}px`) || s;
    let h: string = (height && `${height}px`) || s;
    if (rem) {
      w = pxToRem(w);
      h = pxToRem(h);
    }
    return `width: ${w}; height: ${h}; vertical-align: -0.15em;`;
  });
</script>

<svg {...restProps} aria-hidden="true" class="inline-block overflow-hidden fill-current {className}" {style} {onclick}>
  <use href={symbolId} />
</svg>
